<template>
	<div id="StripApp">
		<b-container>
			<b-row>
				<b-col sm=8 class="title" >
					<h3>Tenha controle dos seus seguros <br><span>Baixe o App Carteira Ciclic em poucos minutos</span></h3>
				</b-col>
				<b-col sm=4 >
					<a href="https://apps.apple.com/br/app/ciclic/id1468520628">
                       <img loading="lazy" width="163" height="48" src="https://ciclic.imgix.net/commons/stores/appstore.png?auto=format,compress&h=48">
                    </a>
					<a href="https://play.google.com/store/apps/details?id=br.com.ciclic.wallet.insurance">
                       <img loading="lazy" width="163" height="48" src="https://ciclic.imgix.net/commons/stores/googleplay.png?auto=format,compress&h=48">
                    </a>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script>
import './StripApp.css'
export default {
	name: 'StripApp'
}
</script>
